export const getEnv = (key: string): string =>
  (import.meta.env.SSR && typeof process !== "undefined"
    ? process.env[key]
    : undefined) ??
  import.meta.env[key] ??
  (typeof process !== "undefined" ? process.env[key] : undefined) ??
  "";
